export = {
  techKind: {
    points: 'Tổng điểm',
    hits_shots: 'Ghi điểm',
    hits_shots_percentage: 'Tỉ lệ ném rổ',
    three_point: '3 điểm',
    three_point_percentage: 'Tỉ lệ ném 3 điểm',
    free_throw_goal: 'Ném phạt',
    free_throw_percentage: 'Tỉ lệ ném phạt',
    rebounds: 'Bắt bóng lật bảng',
    offensive_rebounds: 'Bắt bóng bật bảng của đội tấn công',
    defensive_rebounds: 'Bắt bóng bật bảng của đội phòng thủ',
    assists: 'Hỗ trợ',
    steals: 'Cướp bóng',
    blocks: 'Chặn bóng',
    turnovers: 'Mất bóng',
    fouls: 'Phạm luật',
    number_of_pauses_remaining: 'Số lần tạm dừng còn lại',
    total_pauses: 'Tổng số lần tạm dừng',
  }
};
